import { useState, useEffect, useCallback } from 'react';
import '../../App.css';
import './Users.css';
import { SetAuditTrail, SetAuditTrailBulk } from '../Reports/AuditTrailReportEmployeeSetup';
import axios from '../../api/apiClient';
import { token, domain } from '../Security';
import Register from './components/Register';
import { ChangePasswordForm } from './ChangePassword';

// icons
import HowToRegIcon from '@mui/icons-material/HowToReg';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import EditIcon from '@mui/icons-material/Edit';
import LockResetIcon from '@mui/icons-material/LockReset';
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';

import { UserTemplate } from './components/UserTemplate';
import { LoadingSpinner } from '../../common/Loading';
import { Button, CreateTableNew, SearchBar, GeneralMessage, useGeneralMessage } from '../../common/APICommon';
import { ConfirmationForm } from './forms/ConfirmationForm';

function Users({ user, isHideSideMenu }) {
  // Centralized message management matching Client.js
  const { showMessage, message, isSuccess, showGeneralMessage } = useGeneralMessage();

  var header = [
    "Username",
    "Display Name",
    "Access",
    ""
  ]
  var accessor = [
    "username",
    "employeePersonalInformationFullName",
    "accessTemplateDescription",
    "actions"
  ]

  const [currentPage, setCurrentPage] = useState(1);
  const [loadingRequest, setLoadingRequest] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [employeePersonalInformationId, setEmployeePersonalInformationId] = useState("");
  const [employeePersonalInformationFullName, setEmployeePersonalInformationFullName] = useState("");
  const [employeeId, setEmployeeId] = useState("");
  const [accessTemplateId, setAccessTemplateId] = useState("");
  
  const [oldEmployeePersonalInformationId, setOldEmployeePersonalInformationId] = useState("");
  const [oldAccessTemplateId, setOldAccessTemplateId] = useState("");

  const [filterData, setFilterData] = useState([]);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);

  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");

  const [loading, setLoading] = useState(false);
  const [showRegisterForm, setShowRegisterForm] = useState(false);
  const [showEditForm, setShowEditForm] = useState(false);
  const [showChangePasswordForm, setShowChangePasswordForm] = useState(false);
  const [showUserTemplate, setShowUserTemplate] = useState(false);
  const [showEmployeeForm, setShowEmployeeForm] = useState(false);
  const [showConfirmationForm, setShowConfirmationForm] = useState(false);
  const [isAddState, setIsAddState] = useState(false);

  const apiUrl = domain + "/api/Authentication";

  const resetFormFields = () => {
    setUsername("");
    setPassword("");
    setConfirmPassword("");
    setEmployeePersonalInformationId("");
    setEmployeePersonalInformationFullName("");
    setEmployeeId("");
    setAccessTemplateId("");
    setOldEmployeePersonalInformationId("");
    setOldAccessTemplateId("");
    setSelectedUser(null);
  };

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const response = await axios.get(apiUrl, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })
      setUsers(response.data);
      setFilterData(response.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  }, [apiUrl]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    if (showEditForm && selectedUser) {
      setUsername(selectedUser.username);
      setEmployeePersonalInformationId(selectedUser.employeePersonalInformationId);
      setEmployeePersonalInformationFullName(selectedUser.employeePersonalInformationFullName);
      setEmployeeId(selectedUser.employeePersonalInformationEmployeeId)
      setAccessTemplateId(selectedUser.accessTemplateId);
      setOldEmployeePersonalInformationId(selectedUser.employeePersonalInformationId);
      setOldAccessTemplateId(selectedUser.accessTemplateId);
    }
  }, [showEditForm, selectedUser]);

  const handleFilter = (value) => {
    setCurrentPage(1);
    const lowercaseValue = value.toLowerCase();
    var res = filterData.filter((f) =>
      f.employeePersonalInformationFullName.toLowerCase().includes(lowercaseValue)
    );
    setUsers(res);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoadingRequest(true);

    const data = {
      username,
      password,
      employeePersonalInformationId,
      accessTemplateId
    };

    try {
      await axios.post(apiUrl + `/register`, data, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      await SetAuditTrail({
        setupArea: "Users",
        actionTaken: "insert",
        field: "Register User",
        newValue: `${employeePersonalInformationFullName}`,
        oldValue: "-",
        dateSaved: new Date(),
        savedById: user.id
      });

      await fetchData();
      showGeneralMessage("User registered successfully!", true);
      setShowRegisterForm(false);
      resetFormFields();
    } catch (error) {
      console.error('Error:', error);
      const errorMessage = error.response?.data?.message || "Registration failed";
      showGeneralMessage(errorMessage, false);
    } finally {
      setLoadingRequest(false);
    }
  };

  const handleUpdate = async (event) => {
    event.preventDefault();
    setLoadingRequest(true);

    const payload = {
      id: selectedUser.id,
      employeePersonalInformationId: employeePersonalInformationId,
      accessTemplateId: accessTemplateId
    };
console.log({payload})
    try {
      await axios.put(apiUrl + `/update`, payload, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      let auditInfo = [];
      if (payload.employeePersonalInformationId !== oldEmployeePersonalInformationId) {
        auditInfo.push({
          setupArea: "Users",
          actionTaken: "update",
          field: "Employee",
          newValue: `${payload.employeePersonalInformationId}`,
          oldValue: `${oldEmployeePersonalInformationId}`,
          dateSaved: new Date(),
          savedById: user.id,
        });
      }
      if (payload.accessTemplateId !== oldAccessTemplateId) {
        auditInfo.push({
          setupArea: "Users",
          actionTaken: "update",
          field: "Access Template",
          newValue: `${payload.accessTemplateId}`,
          oldValue: `${oldAccessTemplateId}`,
          dateSaved: new Date(),
          savedById: user.id,
        });
      }

      await SetAuditTrailBulk({ data: auditInfo });
      await fetchData();
      showGeneralMessage("User updated successfully!", true);
      setShowEditForm(false);
      resetFormFields();
    } catch (error) {
      console.error('Error:', error);
      const errorMessage = error.response?.data?.message || "Update failed";
      showGeneralMessage(errorMessage, false);
    } finally {
      setLoadingRequest(false);
    }
  };

  const handleChangePassword = async (event) => {
    event.preventDefault();
    try {
      setLoadingRequest(true);
      await axios.put(apiUrl + `/change-password`, {
        oldPassword,
        newPassword,
        username: selectedUser.username
      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      await SetAuditTrail({
        setupArea: "Users",
        actionTaken: "update",
        field: "Password",
        newValue: `********`,
        oldValue: "********",
        dateSaved: new Date(),
        savedById: user.id
      });
      await fetchData();
      showGeneralMessage("Password changed successfully!", true);
      setShowChangePasswordForm(false);
      setOldPassword("");
      setNewPassword("");
    } catch (error) {
      console.error('Error:', error);
      const errorMessage = error.response?.data?.message || "Password change failed";
      showGeneralMessage(errorMessage, false);
    } finally {
      setLoadingRequest(false);
    }
  };

  const handleResetConfirm = async (event) => {
    event.preventDefault();
    try {
      setLoadingRequest(true);
      await axios.post(apiUrl + `/username/${selectedUser.username}`, [], {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      await SetAuditTrail({
        setupArea: "Users",
        actionTaken: "reset",
        field: "Reset Password",
        newValue: `-`,
        oldValue: "-",
        dateSaved: new Date(),
        savedById: user.id
      });

      showGeneralMessage("Password successfully reset to 'password'", true);
      setShowConfirmationForm(false);
      setSelectedUser(null);
    } catch (error) {
      console.error('Error:', error);
      showGeneralMessage("Password reset failed", false);
    } finally {
      setLoadingRequest(false);
    }
  };

  const handleSelectEmployee = (employee) => {
    setEmployeePersonalInformationFullName(employee?.fullName)
    setEmployeeId(employee?.employeeId)
    setEmployeePersonalInformationId(employee?.id)
  }

  const editHandleClick = (data) => {
    setSelectedUser(data);
    setShowEditForm(true);
  }

  const resetHandleClick = (data) => {
    setSelectedUser(data);
    setShowConfirmationForm(true);
  }

  const actions = [
    {
      name: "Edit",
      tooltip: "edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600 flex !p-[.5px]",
      function: editHandleClick,
      visible: true,
    },
    {
      name: "Change Password",
      tooltip: "change password",
      icon: <LockResetIcon fontSize="small" color="inherit" />,
      className: "bg-red-500 hover:bg-red-600 flex !p-[.5px]",
      function: (data) => { setSelectedUser(data); setShowChangePasswordForm(true); },
      visible: true,
    },
    {
      name: "Reset Password",
      tooltip: "reset password",
      icon: <ChangeCircleIcon fontSize="small" />,
      className: "bg-gray-500 hover:bg-gray-600 flex !p-[.5px]",
      function: resetHandleClick,
      visible: true,
    },
  ];

  return (
    <div>
      <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
        <div className="LeftSpace"></div>
        <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
          <div className="UsersInfo shadow-xl">
            <div className="users-header">
              <h3>Users</h3>
              <div className="mt-5">
                <SearchBar
                  placeholder={"Search by display name..."}
                  handleFilter={handleFilter}
                />
              </div>
              <div className="flex py-2">
                <Button
                  icon={<HowToRegIcon />}
                  name={"Register User"}
                  className={"bg-green-500 hover:bg-green-600 text-white rounded-r-none border-none cursor-pointer"}
                  onClick={() => { resetFormFields(); setShowRegisterForm(true); }}
                />
                <Button
                  icon={<AppRegistrationIcon />}
                  name={"Manage User"}
                  className={"bg-blue-500 hover:bg-blue-600 text-white rounded-l-none border-none cursor-pointer"}
                  onClick={() => setShowUserTemplate(true)}
                />
              </div>
            </div>
            <div className="users-body">
              <div className="users-table container">
                <CreateTableNew
                  tableName={"Users"}
                  headers={header}
                  accessors={accessor}
                  data={users}
                  actions={actions}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  itemsPerPage={10}
                  totalItems={users?.length}
                />
              </div>
            </div>
            <div className="users-footer"></div>
          </div>
        </div>
      </div>

      <Register
        showRegisterForm={showRegisterForm}
        closeRegisterForm={() => { setShowRegisterForm(false); resetFormFields(); }}
        showEditForm={showEditForm}
        closeEditForm={() => { setShowEditForm(false); resetFormFields(); }}
        showEmployeeForm={showEmployeeForm}
        closeEmployeeForm={() => setShowEmployeeForm(false)}
        username={username}
        setUsername={setUsername}
        password={password}
        setPassword={setPassword}
        confirmPassword={confirmPassword}
        setConfirmPassword={setConfirmPassword}
        employeePersonalInformationId={employeePersonalInformationId}
        employeePersonalInformationFullName={employeePersonalInformationFullName}
        employeeId={employeeId}
        accessTemplateId={accessTemplateId}
        setAccessTemplateId={setAccessTemplateId}
        setShowEmployeeForm={setShowEmployeeForm}
        handleSubmit={handleSubmit}
        handleUpdate={handleUpdate}
        handleSelectEmployee={handleSelectEmployee}
      />
      
      <ChangePasswordForm 
        isOpen={showChangePasswordForm}
        onClose={() => setShowChangePasswordForm(false)}
        username={selectedUser?.username}
        oldPassword={oldPassword}
        setOldPassword={setOldPassword}
        newPassword={newPassword}
        setNewPassword={setNewPassword}
        handleUpdate={handleChangePassword}
      />

      <UserTemplate
        isOpen={showUserTemplate}
        onClose={() => setShowUserTemplate(false)}
        isAddState={isAddState}
        setIsAddState={setIsAddState}
        user={user}
      />
      
      <ConfirmationForm 
        isOpen={showConfirmationForm}
        onClose={() => setShowConfirmationForm(false)}
        handleResetConfirm={handleResetConfirm}
      />

      <GeneralMessage
        form={showMessage}
        message={message}
        isSuccess={isSuccess}
      />

      <LoadingSpinner loading={loadingRequest || loading} />
    </div>
  )
}

export default Users;